import { COMPARECIMENTO_CORES } from '../constants/relatorio-cores';
import {
  rotuloLegendaComparecimento,
  type ContagensComparecimentoLegenda,
  type StatusComparecimentoLegenda,
} from '../utils/comparecimento-legenda.utils';

const ITENS_LEGENDA: { key: StatusComparecimentoLegenda; label: string; cor: string }[] = [
  { key: 'presente', label: 'Presente', cor: COMPARECIMENTO_CORES.PRESENTE },
  { key: 'ausente', label: 'Ausente', cor: COMPARECIMENTO_CORES.AUSENTE },
  { key: 'remoto', label: 'Remoto', cor: COMPARECIMENTO_CORES.REMOTO },
  { key: 'impedimento', label: 'Impedimento', cor: COMPARECIMENTO_CORES.IMPEDIMENTO },
];

type ComparecimentoLegendaProps = {
  contagens?: ContagensComparecimentoLegenda;
};

/**
 * Legenda de cores dos status do calendário de comparecimento.
 * Quando informado, exibe a quantidade de ocorrências ao lado de cada item (omitida se zero).
 */
export default function ComparecimentoLegenda({ contagens }: ComparecimentoLegendaProps) {
  return (
    <div className="d-flex flex-wrap gap-3 align-items-center">
      {ITENS_LEGENDA.map((item) => {
        const count = contagens?.[item.key] ?? 0;
        return (
          <span key={item.key} className="d-flex align-items-center gap-1">
            <span
              style={{ width: 12, height: 12, backgroundColor: item.cor, borderRadius: 2, display: 'inline-block' }}
              aria-hidden
            />
            <small>{rotuloLegendaComparecimento(item.label, count)}</small>
          </span>
        );
      })}
    </div>
  );
}
